
    <mat-dialog-content>
        <div class="header">
            <div class="title">
                <img src="/assets/icons/badge-success.svg" alt=""  />
               
                
                {{title}}
            </div>
            
            <div>
                <img src="/assets/icons/Close-new.svg" alt="" (click)="onConfirmClick()" />
            </div> 
        </div>
        <div class="message">{{message}}</div>
    </mat-dialog-content>


